import * as types from './constants';

// Group Flow
export const groupFlowSetInit = data => (
  { type: types.GROUP_FLOW_SET_INIT, payload: data }
);

export const groupFlowSetProp = data => (
  { type: types.GROUP_FLOW_SET_PROP, payload: data }
);

export const groupFlowSetUnsavedChanges = data => (
  { type: types.GROUP_FLOW_SET_UNSAVED_CHANGES, payload: data }
);

export const groupFlowSetNamePopup = data => (
  { type: types.GROUP_FLOW_SET_NAME_POPUP, payload: data }
);

export const groupFlowClear = () => (
  { type: types.GROUP_FLOW_CLEAR }
);

export const groupFlowAddUser = data => (
  { type: types.GROUP_FLOW_ADD_USER, payload: data }
);

export const groupFlowAddGroup = data => (
  { type: types.GROUP_FLOW_ADD_GROUP, payload: data }
);

export const groupFlowRemoveUser = data => (
  { type: types.GROUP_FLOW_REMOVE_USER, payload: data }
);

export const groupFlowRemoveAllUsers = () => (
  { type: types.GROUP_FLOW_REMOVE_ALL_USERS }
);